export const CrumbPrefix = ({ prefix }: { prefix?: string }) => {
    if (!prefix) return null;
    return <span className="oui-label--disabled">{prefix}</span>;
};

CrumbPrefix.displayName = "CrumbPrefix";
